import {
  Dialog,
  Grid,
  IconButton,
  LinearProgress,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useState, lazy, Suspense } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import techniqueChecker from '../utils/techniqueChecker';
import Sensual90 from '@mui/icons-material/HistoryToggleOff';


const DetailsAccordion = lazy(() => import('./DetailsAccordion'));

const MasseuseContainerMobile = ({ masseuse, index }) => {
  const [avatarDialogOpen, setAvatarDialogOpen] = useState(false);
  const [expand, setExpand] = useState(false);
  const handleAvatarDialogOpen = () => {
    setAvatarDialogOpen(true);
  };

  const handleAvatarDialogClose = (value) => {
    setAvatarDialogOpen(false);
  };
  return (
    <Grid
      container
      className="masseuse-container"
      style={{ backgroundColor: masseuse.vacation && 'rgba(212,160, 54,0.3)' }}
    >
      <Grid item xs={12} sm={4} p={0} style={{ textAlign: 'center' }}>
        <Dialog onClose={handleAvatarDialogClose} open={avatarDialogOpen}>
          <IconButton
            aria-label="close"
            onClick={handleAvatarDialogClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.primary.main,
            }}
          >
            <CloseIcon />
          </IconButton>
          {(techniqueChecker(masseuse.technique) ||
            masseuse.name === 'Crystal') && (
            <img src={masseuse?.image} alt={masseuse?.name} />
          )}
          {masseuse.technique === 'Shiatsu' && masseuse.name !== 'Crystal' && (
            <img
              src={
                'https://clubdynasty.ca/wp-content/uploads/2023/10/Female_Silouhette-scaled-1.jpg'
              }
              alt={masseuse?.name}
            />
          )}
        </Dialog>
        <div onClick={handleAvatarDialogOpen} style={{ cursor: 'pointer' }}>
          {(techniqueChecker(masseuse.technique) ||
            masseuse.name === 'Crystal') && (
            <img
              src={masseuse?.image}
              className="masseuse-image"
              alt={masseuse?.name}
            />
          )}
          {masseuse.technique === 'Shiatsu' && masseuse.name !== 'Crystal' && (
            <img
              src={
                'https://clubdynasty.ca/wp-content/uploads/2023/10/Female_Silouhette-scaled-1.jpg'
              }
              className="masseuse-image"
              alt={masseuse?.name}
            />
          )}
        </div>
      </Grid>
      {masseuse.vacation && (
        <Grid item xs={12}>
          <Typography
            variant="h6"
            component="div"
            className="masseuse-vacation-title"
            style={{
              fontWeight: '800',
              marginTop: '20px',
              marginBottom: '-10px',
              color: '#c3892b',
            }}
          >
            RETURNING SOON
          </Typography>
        </Grid>
      )}
      <Grid item xs={12} sm={8} pt={2} pr={2} pl={2} pb={0}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            height: '100%',
          }}
        >
          <Typography
            variant="h3"
            component="div"
            className="masseuse-name"
            style={{
              fontWeight: '800',
            }}
          >
            {masseuse.name.toUpperCase()}{' '}
            {masseuse.new && (
              <Tooltip title="New masseuse">
                <img
                  src="https://clubdynasty.ca/wp-content/uploads/2022/01/new-purple-animation.gif"
                  width="30"
                  alt="New Masseuse"
                ></img>
              </Tooltip>
            )}{' '}
            {masseuse.foot_massage && (
              <Tooltip title="Available for foot massages">
                <img
                  src="https://clubdynasty.ca/wp-content/uploads/2022/11/foot_massage.gif"
                  width="30"
                  alt="Foot Massage"
                ></img>
              </Tooltip>
            )}
            {masseuse.allow_lingam && (
              <Tooltip title="Available for lingam massages">
                <img
                  src="https://clubdynasty.ca/wp-content/uploads/2024/07/lingam_icon.gif"
                  width="30"
                  alt="Foot Massage"
                ></img>
              </Tooltip>
            )}
            {' '}
            {masseuse.sensual90 && (
              <Tooltip title="Available for 90-minute massages">
                <Sensual90 sx={{ color: 'rgb(255, 140, 26)' }} />
              </Tooltip>
            )}
          </Typography>

          {techniqueChecker(masseuse.technique) ? (
            <Typography sx={{ typography: { xs: 'h5' }, textAlign: 'center' }}>
              {masseuse?.age} - {masseuse?.background}
            </Typography>
          ) : (
            <Typography sx={{ typography: { xs: 'h5' }, textAlign: 'center' }}>
              {masseuse?.background}
            </Typography>
          )}
        </div>
      </Grid>
      <Grid item xs={12} pt={0} pr={0} pl={0} pb={1}>
        <Suspense fallback={<LinearProgress />}>
          <DetailsAccordion
            masseuse={masseuse}
            expand={expand}
            setExpand={setExpand}
            index={index}
          />
        </Suspense>
      </Grid>
    </Grid>
  );
};

export default MasseuseContainerMobile;
